import { render } from "./MenuBusinessOverview.vue?vue&type=template&id=28b354f2&scoped=true"
import script from "./MenuBusinessOverview.vue?vue&type=script&lang=js"
export * from "./MenuBusinessOverview.vue?vue&type=script&lang=js"

import "./MenuBusinessOverview.vue?vue&type=style&index=0&id=28b354f2&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b354f2"]])

export default __exports__